import {
  queryUserMembers as publicQueryUserMembers,
  typedQueryUserMembers as publicTypedQueryUserMembers,
} from './members-usermembers-v1-user-member-user-member.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  UserMemberQuery,
  UserMembersQueryBuilder,
  typedQueryUserMembers as universalTypedQueryUserMembers,
} from './members-usermembers-v1-user-member-user-member.universal.js';

function customQueryUserMembers(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryUserMembers(httpClient)(),
    typedQueryFunction: (query: UserMemberQuery) =>
      publicTypedQueryUserMembers(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): UserMembersQueryBuilder;
  function overloadedQuery(
    query: UserMemberQuery
  ): ReturnType<typeof universalTypedQueryUserMembers>;
  function overloadedQuery(query?: UserMemberQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const queryUserMembers: MaybeContext<
  BuildRESTFunction<typeof customQueryUserMembers> &
    typeof customQueryUserMembers
> = /*#__PURE__*/ createRESTModule(customQueryUserMembers);

export {
  PrivacyStatusStatus,
  Status,
  ActivityStatusStatus,
  SortOrder,
  State,
  SiteCreatedContext,
  Namespace,
  DeleteStatus,
} from './members-usermembers-v1-user-member-user-member.universal.js';
export {
  UserMember,
  Image,
  QueryUserMembersRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryUserMembersResponse,
  CursorPagingMetadata,
  Cursors,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MetaSiteSpecialEvent,
  MetaSiteSpecialEventPayloadOneOf,
  Asset,
  SiteCreated,
  SiteTransferred,
  SiteDeleted,
  DeleteContext,
  SiteUndeleted,
  SitePublished,
  SiteUnpublished,
  SiteMarkedAsTemplate,
  SiteMarkedAsWixSite,
  ServiceProvisioned,
  ServiceRemoved,
  SiteRenamed,
  SiteHardDeleted,
  NamespaceChanged,
  StudioAssigned,
  StudioUnassigned,
  SiteUrlChanged,
  SitePurgedExternally,
  OdeditorAssigned,
  OdeditorUnassigned,
  PicassoAssigned,
  PicassoUnassigned,
  WixelAssigned,
  WixelUnassigned,
  StudioTwoAssigned,
  StudioTwoUnassigned,
  UserDomainMediaEnabled,
  UserDomainMediaDisabled,
  EditorlessAssigned,
  EditorlessUnassigned,
  UserMembersQueryResult,
  UserMembersQueryBuilder,
  UserMemberQuerySpec,
} from './members-usermembers-v1-user-member-user-member.universal.js';
export { utils } from './members-usermembers-v1-user-member-user-member.universal.js';
export {
  PrivacyStatusStatusWithLiterals,
  StatusWithLiterals,
  ActivityStatusStatusWithLiterals,
  SortOrderWithLiterals,
  StateWithLiterals,
  SiteCreatedContextWithLiterals,
  NamespaceWithLiterals,
  DeleteStatusWithLiterals,
  CommonQueryWithEntityContext,
  UserMemberQuery,
} from './members-usermembers-v1-user-member-user-member.universal.js';
